import React from "react";
import { Grid, CircularProgress, Divider } from "@material-ui/core";
import { useSelector } from "react-redux";

import Post from "./Post/Post";
import useStyles from "./styles";

const Posts = ({ setCurrentId }) => {
  const posts = useSelector((state) => state.posts);
  const classes = useStyles();
  return !posts.length ? (
    <CircularProgress />
  ) : (
    <>
      <h1>All Posts</h1>
      <Divider className={classes.divider} />
      <Grid
        className={classes.container}
        container
        alignItems="stretch"
        spacing={3}
      >
        {posts
          .slice(0)
          .reverse()
          .map((post, key) => (
            <Grid key={post._id} item xs={12} sm={6}>
              <Post key={post._id} post={post} setCurrentId={setCurrentId} />
            </Grid>
          ))}
      </Grid>
    </>
  );
};
export default Posts;
